import { FETCH_NOTIFICATIONS, FETCH_NOTIFICATION_UNREAD_COUNT, MARK_NOTIFICATION_READ, MARK_NOTIFICATION_UNREAD, } from '../constants/actionTypes';

const initialState = {
  list: [],
  unread: 0
};

export default function notifications(state = initialState, action) {
  switch (action.type) {
    case FETCH_NOTIFICATIONS:
      return {
        ...state,
        list: action.payload
      };

    case FETCH_NOTIFICATION_UNREAD_COUNT:
      return {
        ...state,
        unread: action.payload.unreadCount
      };

      case MARK_NOTIFICATION_READ:
      return {
        ...state,
        list: state.list.map(n =>
          n._id === action.payload ? { ...n, read: true } : n
        ),
        unread: Math.max(0, state.unread - 1)
      };

      case MARK_NOTIFICATION_UNREAD:
      return {
        ...state,
        list: state.list.map(n => n._id === action.payload ? { ...n, read: false } : n),
        unread: state.unread + 1,
      };
      

    default:
      return state;
  }
}
